import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Text } = Typography;

export const TimeBasedTrendsTab: React.FC = () => {
  return (
    <Card>
      <Title level={4}>Coming Soon: Time-Based Analysis</Title>
      <Text type="secondary" className="block">
        • Quotes per day/week/month trends
        <br />
        • Busiest quoting times (staffing insights)
        <br />
        • Seasonal trend analysis
        <br />• Year-over-year comparisons
      </Text>
    </Card>
  );
};
